import axios from 'axios';

const baseURL = '/api';

const getClient = () => {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });
};

const listarConversaciones = (buscar = '') => {
    return getClient().get('/whatsapp/conversaciones', { params: { buscar } }).then((r) => r.data || []);
};

const obtenerConversacion = (id) => {
    return getClient().get(`/whatsapp/conversaciones/${id}`).then((r) => r.data);
};

const obtenerOCrearPorTelefono = ({ telefono, nombre, area }) => {
    return getClient().get('/whatsapp/conversaciones/por-telefono', {
        params: { telefono, nombre, area },
    }).then((r) => r.data);
};

const listarMensajes = (idConversacion) => {
    return getClient().get(`/whatsapp/conversaciones/${idConversacion}/mensajes`).then((r) => r.data || []);
};

const enviarMensaje = (payload) => {
    return getClient().post('/whatsapp/mensajes', payload).then((r) => r.data);
};

const actualizarConversacion = (idConversacion, payload) => {
    return getClient().patch(`/whatsapp/conversaciones/${idConversacion}`, payload).then((r) => r.data);
};

const marcarComoLeida = (idConversacion) => {
    return getClient().patch(`/whatsapp/conversaciones/${idConversacion}/leer`).then((r) => r.data).catch(() => undefined);
};

const whatsappPanelService = {
    listarConversaciones,
    obtenerConversacion,
    obtenerOCrearPorTelefono,
    listarMensajes,
    enviarMensaje,
    actualizarConversacion,
    marcarComoLeida,
};

export default whatsappPanelService;